import React, { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../../../firebaseConfig";

import TutorAnnouncementsDashboard from "./dashboard/TutorAnnouncementsDashboard";
import TutorAnnouncementPostView from "./dashboard/TutorAnnouncementPostView";

import "./TutorAnnouncementsShell.css";

async function loadProfile(user) {
  if (!user) return null;
  try {
    const snap = await getDoc(doc(db, "users", user.uid));
    const data = snap.exists() ? (snap.data() || {}) : {};
    return {
      uid: user.uid,
      email: user.email || data.email || "",
      name: data.name || user.displayName || "User",
      role: data.role || "tutor",
    };
  } catch (e) {
    return {
      uid: user.uid,
      email: user.email || "",
      name: user.displayName || "User",
      role: "tutor",
    };
  }
}

export default function TutorAnnouncements() {
  const [me, setMe] = useState(null);
  const [page, setPage] = useState({ name: "dashboard" }); // dashboard | post

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setMe(null);
        return;
      }
      const prof = await loadProfile(user);
      setMe(prof);
    });
    return () => unsub();
  }, []);

  const goDashboard = () => setPage({ name: "dashboard" });
  const goPost = (id) => setPage({ name: "post", id });

  return (
    <div className="aaShell">
      <div className="aaShellInner">
        {page.name === "dashboard" && (
          <TutorAnnouncementsDashboard me={me} onOpenPost={goPost} />
        )}

        {page.name === "post" && (
          <TutorAnnouncementPostView me={me} announcementId={page.id} onBack={goDashboard} />
        )}
      </div>
    </div>
  );
}
